import { graphConfig } from "../config/authConfig";
import { getAccessToken } from "./authService";

/**
 * Fetches user profile including usageLocation and preferredLanguage
 * (options go to getAccessToken, e.g. { allowRedirect: false })
 */
export async function fetchUserProfile(options) {
  const token = await getAccessToken(options);
  const response = await fetch(graphConfig.graphMeEndpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Graph API error (${response.status}): ${errorText}`);
  }

  return await response.json();
}

/**
 * Fetches the user's registered authentication methods from Microsoft Graph
 */
export async function fetchUserAuthMethods(options) {
  const token = await getAccessToken(options);
  const response = await fetch(graphConfig.graphMethodsEndpoint, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Graph API error (${response.status}): ${errorText}`);
  }

  const data = await response.json();
  return data.value || [];
}
